/**
 *
 * 亚厦股份
 *
 */

import { getUrlParam, getUserInfo } from '@/utils/api';
import { SRSURL, isBuild } from '@/utils/const';

const comein_channel = 'srs';

export const isThirdParty = false;
// export const isThirdParty = sessionStorage.getItem("isComeInMP") == 2 || (location.href.indexOf("isComeInMP=2") != -1);

function Bridge() {
	this.title = '浙商小程序';

	this.hideRelativeRoadshow = true;
}

Bridge.prototype.redirectRoadshowCheck = function () {
	let userInfo = getUserInfo();
	let isInvestor = userInfo.isInvestor;

	let investorUrl = '/package_account/pages/org_auth/index';
	let activityUrl = '/package_roadshow/pages/activity/detail?id=' + this.srsRoadshowActivityId;

	let url = this.srsRoadshowStatus == 1 ? investorUrl : isInvestor ? activityUrl : investorUrl;

	wx.miniProgram.navigateTo({
		url
	});
};

export default Bridge;
